/** הגלילה באפליקציה מתבצעת ב-main, לא ב-window */
export function getScrollContainer() {
  return document.querySelector("main");
}

export function getScrollTop() {
  const el = getScrollContainer();
  return el ? el.scrollTop : window.scrollY;
}

export function scrollContainerTo(top, behavior = "auto") {
  const main = getScrollContainer();
  if (main) main.scrollTo({ top, behavior });
  else window.scrollTo({ top, behavior });
}

export function scrollPageToTop(behavior = "auto") {
  scrollContainerTo(0, behavior);
}

/** מריץ עדכון state שמשנה גובה DOM — ושומר את מיקום הגלילה (טעינה הדרגתית) */
export function runWithScrollPreserved(update) {
  const y = getScrollTop();
  update();
  requestAnimationFrame(() => {
    requestAnimationFrame(() => scrollContainerTo(y, "auto"));
  });
}

const PAGE_SCROLL_RESTORE_KEYS = {
  StoreProducts: ["store_scroll_pos", "store_last_product_id"],
  CategoryProducts: ["cat_scroll_pos", "cat_scroll_pos_click", "cat_last_product_id"],
  Companies: ["companies_scroll_pos", "companies_last_company_id"],
  CompanyProducts: ["company_scroll_pos", "company_scroll_pos_click", "company_last_product_id"],
  Promotions: ["promotions_scroll_pos", "promotions_scroll_pos_click", "promotions_last_product_id"],
};

export function clearPageScrollRestore(page) {
  (PAGE_SCROLL_RESTORE_KEYS[page] || []).forEach((key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (_) {}
  });
}

export function hasPageScrollRestore(page) {
  return (PAGE_SCROLL_RESTORE_KEYS[page] || []).some((key) => {
    try {
      return sessionStorage.getItem(key) != null;
    } catch (_) {
      return false;
    }
  });
}

/** לחיצה על פריט בתפריט — גלילה לראש; מנקה שחזור רק בכניסה מדף אחר */
export function handleMenuNavigation(page, isCurrentPage) {
  if (isCurrentPage) {
    scrollPageToTop("smooth");
    return;
  }
  clearPageScrollRestore(page);
  scrollPageToTop("auto");
}
